import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import platbaApi from 'services/bankid/platba';
import { IZadostData } from 'services/bankid/zadost';
import formatNumber from 'utils/formatNumber';

interface IOBJED {
    zadostData?: IZadostData;
    contactInfoEmail?: string;
    contactInfoPhone?: string;
}

const OBJED: React.FC<IOBJED> = props => {
    const { zadostData, contactInfoEmail, contactInfoPhone } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>(); // Bank ID token sebran z urlky

    useEffect(() => {
        return () => setDisableSubmit(false);
    }, []);

    const routeChange = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet/bankid';
        history.push(path);
    };

    const onClick = () => {
        token &&
            !disableSubmit &&
            zadostData?.idzadosti &&
            (setDisableSubmit(true),
            platbaApi(token, zadostData?.idzadosti)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then((resp: any) => {
                    window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky platebni brany
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                    setDisableSubmit(false);
                }));
    };

    let castka = 90;

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : (
                <>
                    {/* <Paragraph text="SHRNUTI_OBJEDNAVKY" strong={true} /> */}
                    <h1>
                        <TranslateText>SHRNUTI_OBJEDNAVKY</TranslateText>
                    </h1>

                    {/* <Paragraph text="ZADATEL" strong={true} /> */}
                    <h3>
                        <TranslateText>ZADATEL</TranslateText>
                    </h3>
                    <div className="section-zadatel">
                        <Row>
                            <Col span={24} className="detail">
                                <TranslateText>{zadostData?.jmeno ? zadostData?.jmeno : '-'}</TranslateText>{' '}
                                <TranslateText>{zadostData?.prijmeni ? zadostData?.prijmeni : '-'}</TranslateText>
                            </Col>
                        </Row>

                        <Row>
                            <Paragraph
                                text={zadostData?.email ? zadostData?.email : contactInfoEmail ? contactInfoEmail : '-'}
                            />
                        </Row>

                        <Row>
                            {/* <Paragraph
                                text={
                                    zadostData?.telefon
                                        ? zadostData?.telefon
                                        : contactInfoPhone
                                        ? contactInfoPhone
                                        : '-'
                                }
                            /> */}
                            <Paragraph
                                text={
                                    zadostData?.telefon
                                        ? formatNumber(zadostData.telefon)
                                        : formatNumber(contactInfoPhone)
                                }
                            />
                        </Row>

                        <Row>
                            <Paragraph text="FORMA_UHRADY" />
                        </Row>
                    </div>

                    <Row>
                        <Col span={24} className="detail">
                            <TranslateText>CELKOVA_CASTKA</TranslateText>: {castka + ' Kč'}
                        </Col>
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent
                            htmlType="submit"
                            buttontext="ZAPLATIT"
                            onClick={onClick}
                            disabled={disableSubmit}
                        />
                    </Row>
                </>
            )}
        </>
    );
};

export default OBJED;
